import type { StyleSpecification } from "maplibre-gl";

export const mainLayerId = "raster_main";

export const styleCuzkBase: StyleSpecification = {
    version: 8,
    glyphs: `https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf`,
    sprite: "https://tiles.openfreemap.org/sprites/ofm_f384/ofm",
    sources: {
        rasterSource: {
            type: 'raster',
            tiles: [
                'https://ags.cuzk.cz/arcgis1/rest/services/ZTM_WM/MapServer/tile/{z}/{y}/{x}?blankTile=false'
            ],
            bounds: [11.8404431, 48.3979108, 19.3111461, 50.9287239],
            tileSize: 256,
            maxzoom: 18,
            minzoom: 2,
        },
    },
    layers: [
        {
            id: 'background',
            type: 'background',
            paint: {
                "background-color": "#fff",
            },
        },
        {
            id: mainLayerId,
            type: 'raster',
            source: 'rasterSource',
            minzoom: 0,
            maxzoom: 23,
            paint: {
                "raster-opacity": 0.8,
            },
        }
    ]
};

export const styleCuzkOrto: StyleSpecification = {
    version: 8,
    glyphs: `https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf`,
    sprite: "https://tiles.openfreemap.org/sprites/ofm_f384/ofm",
    sources: {
        rasterSource: {
            type: 'raster',
            tiles: [
                'https://ags.cuzk.cz/arcgis1/rest/services/ORTOFOTO_WM/MapServer/tile/{z}/{y}/{x}?blankTile=false'
            ],
            bounds: [11.8404431, 48.3979108, 19.3111461, 50.9287239],
            tileSize: 256,
            maxzoom: 23,
            minzoom: 2,
        },
    },
    layers: [
        {
            id: mainLayerId,
            type: 'raster',
            source: 'rasterSource',
            'minzoom': 0,
            'maxzoom': 23,
        }
    ]
};

export const mapTypeList = <const>{
    "cuzk_base": "CUZK základní",
    "cuzk_orto": "CUZK ortofoto",
};
export type MapType = keyof typeof mapTypeList;
export const mapStyles: Record<MapType, StyleSpecification> = {
    cuzk_base: styleCuzkBase,
    cuzk_orto: styleCuzkOrto,
};
